import { AxiosError } from 'axios';

type LocalizeText = (textId: string, defaultText: string) => string;

type ErrorResponse = {
  message?: string;
};

type GetPaymentMutationErrorMessageParams = {
  error: unknown;
  fallbackTextId: string;
  fallbackText: string;
  lt: LocalizeText;
};

const STRIPE_ERROR_CODE_SEPARATOR = '; code:';

export const getPaymentMutationErrorMessage = ({
  error,
  fallbackTextId,
  fallbackText,
  lt,
}: GetPaymentMutationErrorMessageParams) => {
  if (!(error instanceof AxiosError)) {
    return lt(fallbackTextId, fallbackText);
  }

  const responseMessage = (error.response?.data as ErrorResponse | undefined)
    ?.message;

  if (!responseMessage) {
    return lt(fallbackTextId, fallbackText);
  }

  if (!responseMessage.includes(STRIPE_ERROR_CODE_SEPARATOR)) {
    return responseMessage;
  }

  const message = responseMessage
    .slice(0, responseMessage.indexOf(STRIPE_ERROR_CODE_SEPARATOR))
    .trim();
  const codeStartIndex =
    responseMessage.indexOf(STRIPE_ERROR_CODE_SEPARATOR) +
    STRIPE_ERROR_CODE_SEPARATOR.length;
  const codeEndIndex = responseMessage.indexOf(';', codeStartIndex);
  const code = responseMessage
    .slice(codeStartIndex, codeEndIndex !== -1 ? codeEndIndex : undefined)
    .trim();

  return lt(`stripeError.${code}`, message);
};
